import { render, staticRenderFns } from "./PermissionsWrapper.vue?vue&type=template&id=275fea1b&scoped=true"
import script from "./PermissionsWrapper.vue?vue&type=script&lang=ts"
export * from "./PermissionsWrapper.vue?vue&type=script&lang=ts"
import style0 from "./PermissionsWrapper.vue?vue&type=style&index=0&id=275fea1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vu_qgmhcv2zwyplqohcijlq2qcl3q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275fea1b",
  null
  
)

export default component.exports